import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=3db28aa3&scoped=true"
import script from "./search-bar.vue?vue&type=script&lang=js"
export * from "./search-bar.vue?vue&type=script&lang=js"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=3db28aa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db28aa3",
  null
  
)

export default component.exports